// components/ui/Toast.tsx — Radix UI Toast primitive wrapper

import * as RadixToast from '@radix-ui/react-toast';
import styles from './Toast.module.css';

export interface ToastProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  description?: string;
  type?: 'success' | 'error' | 'info';
}

const EMOJI_MAP = {
  success: '✓',
  error: '⚠️',
  info: 'ℹ️',
};

export function ToastProvider({ children }: { children: React.ReactNode }) {
  return (
    <RadixToast.Provider swipeDirection="down">
      {children}
      <RadixToast.Viewport className={styles.viewport} />
    </RadixToast.Provider>
  );
}

export function Toast({ open, onOpenChange, title, description, type = 'info' }: ToastProps) {
  return (
    <RadixToast.Root className={styles.root} open={open} onOpenChange={onOpenChange}>
      <div className={styles.content}>
        <span className={styles.icon}>{EMOJI_MAP[type]}</span>
        <div>
          <RadixToast.Title className={styles.title}>{title}</RadixToast.Title>
          {description && (
            <RadixToast.Description className={styles.description}>
              {description}
            </RadixToast.Description>
          )}
        </div>
      </div>
      <RadixToast.Close className={styles.closeBtn} aria-label="Close toast">
        ✕
      </RadixToast.Close>
    </RadixToast.Root>
  );
}
